import { useMemo } from 'react';

import { calculateChangedValues } from 'components/DEBForm/Utils/DebFormSectionUtil';

import {
  calcExpertTriggers,
  calcInstallerTriggersIds,
  createInitialValues,
  createValidationSchema,
  updateExpertTriggersForMainGas,
} from './utils';

export const useDebFormSecondPageLogic = (
  valuesFirstPage,
  initialValuesFirstPage,
  installerStatusSummary,
  installer
) =>
  useMemo(() => {
    const changedValues = calculateChangedValues(valuesFirstPage, initialValuesFirstPage);

    const documentTriggerIdsOfInstallerFields = calcInstallerTriggersIds(changedValues);

    const [expertTriggers, documentTriggerIds] = calcExpertTriggers(
      valuesFirstPage,
      initialValuesFirstPage,
      installerStatusSummary,
      documentTriggerIdsOfInstallerFields
    );

    updateExpertTriggersForMainGas(
      valuesFirstPage,
      installerStatusSummary,
      documentTriggerIds,
      expertTriggers
    );

    const initialValues = createInitialValues(
      changedValues,
      documentTriggerIds,
      expertTriggers,
      installer
    );

    const validationSchema = createValidationSchema(
      valuesFirstPage,
      initialValues,
      installerStatusSummary,
      documentTriggerIds,
      expertTriggers
    );

    return {
      initialValues,
      validationSchema,
    };
  }, [valuesFirstPage, initialValuesFirstPage, installerStatusSummary, installer]);
